import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import "@/assets/tailwind.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import PrimeVue from "primevue/config";
import MultiSelect from "primevue/multiselect";
import Tailwind from "primevue/passthrough/tailwind";
import highcharts from "highcharts-vue";
const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(PrimeVue, { unstyled: true, pt: Tailwind });
app.component("MultiSelect", MultiSelect);
app.component("VueDatePicker", VueDatePicker);
app.component("highcharts", highcharts);
app.mount("#app");
